import { render, staticRenderFns } from "./BackButton.vue?vue&type=template&id=6cabb67b&scoped=true"
import script from "./BackButton.vue?vue&type=script&lang=js"
export * from "./BackButton.vue?vue&type=script&lang=js"
import style0 from "./BackButton.vue?vue&type=style&index=0&id=6cabb67b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cabb67b",
  null
  
)

export default component.exports